import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";

import Auth from "@/pages/Auth";
import ChildHome from "@/pages/child/Home";
import ChildPlay from "@/pages/child/Play";
import Rewards from "@/pages/child/Rewards";
import ParentDashboard from "@/pages/parent/Dashboard";
import ParentSettings from "@/pages/parent/Settings";
import Messages from "@/pages/Messages";
import SharedHome from "@/pages/shared/Home";

const RequireRole = ({ role, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-childhub font-display text-xl">Loading...</div>;
  if (!user) return <Navigate to="/login" replace/>;
  if (role && user.role !== role) return <Navigate to={user.role === "parent" ? "/parent" : "/child"} replace/>;
  return children;
};

const RootRedirect = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-childhub font-display text-xl">Loading...</div>;
  if (!user) return <Navigate to="/login" replace/>;
  return <Navigate to={user.role === "parent" ? "/parent" : "/child"} replace/>;
};

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors/>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect/>}/>
          <Route path="/login" element={<Auth mode="login"/>}/>
          <Route path="/register" element={<Auth mode="register"/>}/>

          <Route path="/child" element={<RequireRole role="child"><ChildHome/></RequireRole>}/>
          <Route path="/child/play/:id" element={<RequireRole role="child"><ChildPlay/></RequireRole>}/>
          <Route path="/child/rewards" element={<RequireRole role="child"><Rewards/></RequireRole>}/>
          <Route path="/child/messages" element={<RequireRole role="child"><Messages variant="child"/></RequireRole>}/>

          <Route path="/parent" element={<RequireRole role="parent"><ParentDashboard/></RequireRole>}/>
          <Route path="/parent/messages" element={<RequireRole role="parent"><Messages variant="parent"/></RequireRole>}/>
          <Route path="/parent/settings" element={<RequireRole role="parent"><ParentSettings/></RequireRole>}/>

          <Route path="/shared" element={<RequireRole><SharedHome/></RequireRole>}/>

          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
